import { OfflineDataSourceFieldEnum } from "@/enums";

export const offlineDataSourceFieldsData = {
    keys: {
        amount: "amount",
        dateTime: "dateTime",
        metadata: "metadata",
        name: "name",
        otherTransactionIds: "otherTransactionIds",
        status: "status",
        uniqueTransactionId: "uniqueTransactionId",
    },
    others: {
        allData: "allData",
        allStatuses: "allStatuses",
        excludedMetadata: "excludedMetadata",
        pending: "pending",
        posted: "posted",
        sessionId: "sessionId",
    },
    types: {
        amount: OfflineDataSourceFieldEnum.AMOUNT,
        dateTime: OfflineDataSourceFieldEnum.DATE_TIME,
        metadata: OfflineDataSourceFieldEnum.METADATA,
        name: OfflineDataSourceFieldEnum.NAME,
        otherTransactionIds: OfflineDataSourceFieldEnum.OTHER_TRANSACTION_IDS,
        status: OfflineDataSourceFieldEnum.STATUS,
        uniqueTransactionId: OfflineDataSourceFieldEnum.UNIQUE_TRANSACTION_ID,
    },
};
